import { el } from 'redom';

import NativeHorizontalToggle from 'generics/components/horizontal-toggle/native';

import './index.scss';

class MiscellaneousSettingsPanel {

  constructor(configuration) {

    this.menu = configuration.menu;
    this.node = configuration.node;
    this.onChange = configuration.onChange;

    this.miscellaneousSettings = {
      alwaysFullWidth: this.node.properties.alwaysFullWidth || false,
      forceCenterAlign: this.node.properties.forceCenterAlign || false
    };

    this.hamburgerToggle = new NativeHorizontalToggle({
      label: 'Full width',
      value: this.miscellaneousSettings.alwaysFullWidth,
      size: 'small',
      onChange: this.handleChange.bind(this)
    });

    this.centerAlignToggle = new NativeHorizontalToggle({
      label: 'Show center aligned',
      value: this.miscellaneousSettings.forceCenterAlign,
      size: 'small',
      onChange: this.handleCenterAlignChange.bind(this)
    });
    this.el = el('.miscellaneous-settings-panel-main', [this.hamburgerToggle, this.centerAlignToggle]);

  }

  handleChange(value) {

    this.miscellaneousSettings.alwaysFullWidth = value;

    this.onChange(structuredClone(this.miscellaneousSettings));

  }

  handleCenterAlignChange(value) {

    this.miscellaneousSettings.forceCenterAlign = value;

    this.onChange(structuredClone(this.miscellaneousSettings));

  }

  update(configuration) {

    this.manager = configuration.manager;

  }

}

export default MiscellaneousSettingsPanel;